import { render } from "./Receipt.vue?vue&type=template&id=36f0839a"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Receipt.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36f0839a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36f0839a', __exports__)) {
    api.reload('36f0839a', __exports__)
  }
  
  module.hot.accept("./Receipt.vue?vue&type=template&id=36f0839a", () => {
    api.rerender('36f0839a', render)
  })

}


export default __exports__